var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightarrowDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8297 19.0013C13.6803 19.0018 13.5327 18.9688 13.3977 18.9048C13.2627 18.8407 13.1438 18.7473 13.0497 18.6313L8.21968 12.6313C8.0726 12.4523 7.99219 12.2279 7.99219 11.9963C7.99219 11.7646 8.07259 11.5402 8.21968 11.3613L13.2197 5.36125C13.3894 5.15703 13.6333 5.02861 13.8978 5.00423C14.1622 4.97985 14.4255 5.06151 14.6297 5.23125C14.8339 5.40099 14.9623 5.6449 14.9867 5.90933C15.0111 6.17375 14.9294 6.43703 14.7597 6.64125L10.2897 12.0013L14.6097 17.3613C14.732 17.508 14.8096 17.6868 14.8335 17.8763C14.8574 18.0659 14.8265 18.2583 14.7444 18.4308C14.6624 18.6034 14.5326 18.7488 14.3705 18.8499C14.2084 18.9509 14.0207 19.0035 13.8297 19.0013Z",
    fill: "#8F8F8F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 7.5,
    stroke: "#8F8F8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrowDisabled);
export default __webpack_public_path__ + "static/media/rightarrow-disabled.2e1ed79ff631010ecc3fb1f90f3adcd6.svg";
export { ForwardRef as ReactComponent };